export default {
  serviceOrders: 'Actividades',
  profile: 'Perfil',
  person: 'Personas',
  location: 'Lugares',
  fleet: 'Flotas',
  users: 'Usuarios',
  welcomeAssistant: '¡Hola! Soy el asistente virtual de BTime. ¿Cómo puedo ayudarte hoy?',
  btimeAI: 'Btime AI',
  satisfactionSurvey: 'Encuesta de Satisfacción',
  chatSupport: 'Soporte vía chat',
  dashboard: 'Dashboard',
  processes: 'Procesos',
  map: 'Mapa',
  forms: 'Formularios',
  nonCompliance: 'No conformidad',
  nonComplianceServiceOrders: 'No conformidades de actividades',
  nonComplianceForms: 'No conformidades de formularios',
  availability: 'Disponibilidad',
  dynamicServiceOrders: 'Actividades Dinámicas',
  stocks: 'Stock',
  settings: 'Configuraciones',
  generalRegistrations: 'Registros generales',
  checklists: 'Cuestionarios',
  masks: 'Máscaras',
  assets: 'Activos',
  segmentation: 'Segmentación',
  integrations: 'Integraciones',
  webhook: 'Webhook',
  modulesAndPermissions: 'Módulos y permisos',
  createPlaceType: 'Crear tipo de lugar',
  projects: 'Proyectos',
  systemLogs: 'Logs del sistema',
  triggerHistory: 'Historial de disparadores',
  clearCache: 'Limpiar caché',
  changePassword: 'Cambiar contraseña',
  logout: 'Cerrar sesión'
}
